import { IProduct, IProductResource } from '@/services/product';
import { CheckList } from './';

const isResourceComplete = (
  resourceType: string,
  data: any,
) => {
  const resources = data[`${resourceType}s`];
  return !!resources.length &&
    !resources.find((resource: IProductResource<any>) => (
      !resource.resource_id || !resource.name || !resource.qty
    ),
  );
};

export const titles = {
  COMPONENTS: 'Add component information',
  IMAGERY: 'Add product imagery',
  MATERIALS: 'Add material information',
  NAME: 'Fill in the name',
  PRICING: 'Add pricing information',
  PROPERTIES: 'Add product details',
  SIZES: 'Add size information',
  WASHING: 'Add sufficient washing instructions',
};

export default [
  {
    title: titles.NAME,
    isComplete: data => !!data.name,
    meta: {
      category: 'Basics',
    },
  },
  {
    title: titles.IMAGERY,
    isComplete: data => !!data.assets.length,
    meta: {
      category: 'Basics',
    },
  },
  {
    title: titles.WASHING,
    isComplete: data => {
      const instructions: string[] = [];
      for (const type in data.care_symbols) {
        instructions.push(...data.care_symbols[type]);
      }
      return instructions.length > 4;
    },
    meta: {
      category: 'Basics',
    },
  },
  {
    title: titles.PRICING,
    isComplete: data => (
      data.prices.length
        && !data.prices.find(price => !price.amount || !price.category || !price.currency)
    ),
    meta: {
      category: 'Basics',
    },
  },
  {
    title: titles.PROPERTIES,
    isComplete: data => (
      data.properties.length
        && !data.properties.find(prop => !prop.key || !prop.value)
    ),
    meta: {
      category: 'Basics',
    },
  },
  {
    title: titles.SIZES,
    isComplete: data => !!data.sizes.length,
    meta: {
      category: 'Basics',
    },
  },
  {
    title: titles.MATERIALS,
    isComplete: data => isResourceComplete('material', data),
    meta: {
      category: 'Resources',
    },
  },
  {
    title: titles.COMPONENTS,
    isComplete: data => isResourceComplete('component', data),
    meta: {
      category: 'Resources',
    },
  },
] as Array<CheckList<IProduct>>;
